// extracted by mini-css-extract-plugin
module.exports = {"header":"index_header__2ohmX","mainLayout":"index_mainLayout__fB1hk","homeHeader":"index_homeHeader__1l-er"};